import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11.117",
  height: "11.119"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "* ikona X KASUJ 9x9" }, [
      _createElementVNode("g", {
        fill: "none",
        stroke: "#626997",
        "stroke-linecap": "round",
        "stroke-width": "1.5",
        "data-name": "Group 8785"
      }, [
        _createElementVNode("path", {
          d: "m10.056 1.063-8.994 8.994",
          "data-name": "Path 15872"
        }),
        _createElementVNode("path", {
          d: "M10.056 10.056 1.062 1.062",
          "data-name": "Path 15873"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }